import Heading from '../../../Component/pages/global expo/Heading'
import Eligibility_Criteria from "./Eligibility_Criteria"
import Steps from "./Steps"
import Visa from './Visa';
import Usa from './Usa';
export default function Globalline() {
    return (
      <div>
     <div>
        <Heading/>
     </div>
      <div>
      <Eligibility_Criteria/>
     </div>
     <div>
      <Steps/>
     </div>
     <div>
      <Visa />
     </div>
     <div>
      <Usa />
     </div> 
     </div>
    );
  }